import React, { ReactElement } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'
import { Button } from 'ui/Buttons'
import { navigate } from 'gatsby'
import { useAppSelector } from 'store/hooks'
import { getStarted } from 'components/HomePage/Header/menus'
import { TippyProps } from '@tippyjs/react'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { GetStartedDropdown } from 'components/HomePage/Header'

interface ButtonGroupProps {
  sx?: ThemeUIStyleObject
  buttonSx?: ThemeUIStyleObject
  tippyprops?: TippyProps
  dropdownContainerSx?: ThemeUIStyleObject
}

const compactStyles = { py: '0.6rem', px: '1.2rem', fontSize: '1.5rem', fontWeight: 600 }

export function ButtonGroup({
  sx,
  tippyprops,
  dropdownContainerSx,
  buttonSx = {},
}: ButtonGroupProps): ReactElement {
  const sessionToken = useAppSelector(s => s.session.sessionToken)
  const isMobileOrTablet = useBreakpointIndex() < 2

  return (
    <Flex
      sx={{
        gap: '0.8rem',
        flexShrink: 0,
        alignItems: 'center',
        ...sx,
      }}
    >
      {sessionToken ? (
        <Button
          name="button"
          ariaLabel="go to dashboard"
          variant="roundedSecondary"
          sx={{
            ...(isMobileOrTablet ? compactStyles : {}),
            ...buttonSx,
          }}
          onClick={() => {
            navigate('/dashboard/profiles')
          }}
        >
          Go to Dashboard
        </Button>
      ) : (
        <>
          <Button
            name="button"
            ariaLabel="login button"
            data-testid="org-login-button"
            variant="roundedSimple"
            sx={{
              whiteSpace: 'nowrap',
              px: '1.6rem',
              '@media screen and (min-width: 1120px) and (max-width: 1250px)': {
                px: '0.8rem',
              },
              ...(isMobileOrTablet ? compactStyles : {}),
              ...buttonSx,
            }}
            onClick={() => {
              navigate('/login')
            }}
          >
            Log in
          </Button>
          <GetStartedDropdown
            dropdownItems={getStarted}
            tippyprops={tippyprops}
            sxContainer={dropdownContainerSx}
          >
            Get Started
          </GetStartedDropdown>
        </>
      )}
    </Flex>
  )
}
